import { Button } from "reactstrap";

import { DetailsButton } from "./CommonComponents";
import { deleteCol, viewCol } from "./Helpers/structureConstants";

export const getDetailsColumn = (setData, toggleModalState) => ({
  ...viewCol,
  Cell: ({ row }) => (
    <DetailsButton
      original={row.original}
      setValues={setData}
      toggleModalState={toggleModalState}
    />
  ),
});

export const getRemoveColumn = ({ isDisabled, setValues, toogleModal }) => ({
  ...deleteCol,
  Cell: ({ row }) => (
    <Button
      disabled={isDisabled}
      color={"danger"}
      onClick={() => {
        toogleModal?.(true);
        setValues?.(row.original);
      }}
    >
      Canc.
    </Button>
  ),
});
